import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9004 3.75C10.21 3.75 9.65039 4.30964 9.65039 5V6.25H14.9004C16.4192 6.25 17.6504 7.48122 17.6504 9V16.25H18.9004C19.5907 16.25 20.1504 15.6904 20.1504 15V5C20.1504 4.30964 19.5907 3.75 18.9004 3.75H10.9004ZM17.6504 17.75H18.9004C20.4192 17.75 21.6504 16.5188 21.6504 15V5C21.6504 3.48122 20.4192 2.25 18.9004 2.25H10.9004C9.38161 2.25 8.15039 3.48122 8.15039 5V6.25H6.90039C5.38161 6.25 4.15039 7.48122 4.15039 9V19C4.15039 20.5188 5.38161 21.75 6.90039 21.75H14.9004C16.4192 21.75 17.6504 20.5188 17.6504 19V17.75ZM6.90039 7.75C6.21003 7.75 5.65039 8.30964 5.65039 9V19C5.65039 19.6904 6.21003 20.25 6.90039 20.25H14.9004C15.5907 20.25 16.1504 19.6904 16.1504 19V9C16.1504 8.30964 15.5907 7.75 14.9004 7.75H6.90039Z"
        fill={colorValue}
      />
    </svg>
  );
};
